import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/price-to-cash-flow-calculator',
  component: () => import('../../routes/PriceToCashFlowCalculator.svelte'),
  card: {
    id: 'price-to-cash-flow-calculator',
    title: 'Price-to-Cash-Flow (P/CF)',
    description:
      'Calculate the P/CF ratio to value a stock against its operating cash flow. Includes P/FCF variant, cash flow yield, and quality spread.',
    icon: 'payments',
    iconBgClass: 'bg-teal-50',
    iconTextClass: 'text-teal-600',
    href: '/price-to-cash-flow-calculator',
    category: 'Savings & Investing',
  },
  seo: {
    title: 'Price-to-Cash-Flow (P/CF) Ratio Calculator – Free Valuation Tool',
    description:
      'Calculate the Price-to-Cash-Flow (P/CF) ratio to evaluate whether a stock is overvalued or undervalued relative to its operating cash flow. Includes P/FCF, cash flow yield, and sector benchmarks.',
  },
};

export default meta;
